module.exports = __webpack_public_path__ + "static/img/clock.2ae5f8e3.png";